export default __webpack_public_path__ + "images/loginLogo.2d12f833be292a2ba9e34e4c064b9b1c.svg";